module.exports = __webpack_public_path__ + "img/spec_small.6819cb9d.jpg";